<template>
    <div class="container">
        <div class="logo">
          <img src="../assets/images/logo.png" alt="">
        </div>
      <div v-if="login_type == 'password'" class="form">
        <div class="group c_flex ">
          <div class="c_flex_center c_flex fieldname">
            手机
          </div>
          <div class="content c_flex_1 c_item_center c_flex c_m_l_10">
            <input type="tel" maxlength="11" v-model="username" placeholder="请输入手机号码">
          </div>
        </div>
        <div class="group c_flex c_item_center" style="margin-bottom:10px;">
          <div class="border c_flex_1 c_flex">
            <div class="c_flex_center c_flex fieldname">
              密码
            </div>
            <div class="content c_flex_1 c_flex c_item_center c_m_l_10">
              <input class="c_flex_1" type="password" v-model="password" placeholder="请输入密码">
              <van-icon class="eye" name="closed-eye" @click="eyeClick($event)" />
            </div>
          </div>
        </div>
        <div class="help">
          <van-checkbox icon-size="16px" v-model="remember_pwd" checked-color="rgb(3,162,228)"><span style="color:#8c8c8c;">保存密码</span></van-checkbox>
          <span @click="forgetClick()">
            忘记密码?
          </span>
        </div>
        <div class="group">
          <div class="opera bg_blue c_flex c_flex_center" @click="login">登录</div>
        </div>
      </div>
      <div v-else class="form">
          <div class="group c_flex ">
              <div class="img c_flex_center c_flex">
                <i class="iconfont icon-wode1"></i>
              </div>
              <div class="content c_flex_1 c_item_center c_flex">
                <input type="tel" maxlength="11" v-model="username" placeholder="请输入手机号码">
              </div>
          </div>
          <div class="group c_flex c_item_center" style="margin-bottom:10px;">
              <div class="border c_flex_1 c_flex">
                  <div class="img c_flex_center c_flex">
                    <i class="iconfont icon-iconfontmima"></i>
                  </div>
                  <div class="content c_flex_1 c_flex c_item_center">
                    <input class="c_flex_1" type="tel" maxlength="4" v-model="sms" placeholder="请输入验证码">
                  </div>
              </div>
              <div class="time c_flex c_flex_center" :class="isSend?'bg_blue':'bg_gray'" @click="sendCode">{{tips}}</div>
          </div>
          <div class="help">
            <van-checkbox icon-size="16px" v-model="remember" checked-color="rgb(3,162,228)"><span style="color:#8c8c8c;">记住手机号</span></van-checkbox>
          </div>
          <div class="group">
              <div class="opera bg_blue c_flex c_flex_center" @click="login">登录</div>
          </div>
        </div>
      <div class="login_type">
        <span v-if="login_type == 'password'" @click="loginTypeChange()">- 使用验证码登录 -</span>
        <span v-else @click="loginTypeChange()" >- 使用密码登录 -</span>
      </div>

      <!--选择角色-->
      <mt-actionsheet
        :actions="roleParam.roleList"
        :closeOnClickModal="false"
        v-model="roleParam.visible">
      </mt-actionsheet>

    </div>
</template>

<script>
    export default {
        name: "login",
        data:function () {
            return {
              username:'',
              password:'',
              id:'',
              sms:'',
              isSend:true,
              tips:'发送验证码',  //重新发送
              login_type:'sms', //登录方式
              remember:true, //记住手机号
              remember_pwd:true, //保存密码
              roleParam:{
                visible:false,
                roleList:[],
              },
              transfer:{
                url:'',
                urlObj:{},
              },
            }
        },
      mounted:function(){
        this.id = '';
        if(!!localStorage['userinfo_username']){
          this.username = localStorage['userinfo_username'];
        }
        if(!!localStorage['userinfo_userpwd']){
          this.password = localStorage['userinfo_userpwd'];
        }
        let url = this.getUrlParams('url')||"";
        if(url){
          let obj = this.$comm.urlFormat(window.location.href.split('?')[1]);
          this.transfer.url = url;
          this.transfer.urlObj = obj;
        }
        this.$indicator.close();
      },
      methods:{
          login:function (id) {
            var $that = this;
            // localStorage.clear();
            if(!this.username || this.username.length < 11){ this.$toast("请输入正确手机号"); return;}
            var params = {
              'username':this.username,
              'login_type':this.login_type,
              "login_roleid":this.id||'',
            };
            if(this.login_type == 'password'){
              if(!this.password){
                this.$toast("请输入密码");
                return;
              }
              if(this.password.length < 6){
                this.$toast("请输入至少6位密码");
                return;
              }
              params['password'] = this.password;

            }else{
              if(!this.sms){
                this.$toast("请输入验证码");
                return;
              }
              params['sms'] = this.sms;
            }
            this.$indicator.open();
            this.$ajax.get(this.$$api.mobile.login,params,function (res) {
              $that.$indicator.close();
              if (res.status == 200) {
                if(res.data.flag == 'fail'){
                  $that.$toast(res.data.msg);
                  $that.id = '';
                  $that.roleParam.visible = false;
                }else if(res.data.flag == 'relogin'){
                  let roleList = res.data.roledata||[];
                  let customerRoleObj;
                  let temp = roleList.map(sub=>{
                    sub.name = sub.rolename;
                    sub.method = $that.chooseRole;
                    if(sub.rolename=='业主'){
                      customerRoleObj = sub;
                    }
                    return sub;
                  });
                  $that.roleParam.roleList = temp;
                  if($that.transfer.url && customerRoleObj){
                    $that.chooseRole(customerRoleObj);
                  }else{
                    $that.roleParam.visible = true;
                  }
                }else{
                  var obj = {};
                  obj.usertype = res.data.userType;
                  obj.iswarranty = res.data.iswarranty;
                  localStorage['userinfo'] = JSON.stringify(obj);
                  //是否记住手机号
                  if($that.username){
                    if($that.remember){
                      localStorage['userinfo_username'] = $that.username;
                    }else{
                      localStorage.removeItem('userinfo_username');
                    }
                  }
                  //首次登录重置密码
                  if(res.data.status == '-1'){
                    localStorage['reset_phone'] = $that.username;
                    $that.$router.push('password-reset');
                    return;
                  }
                  if($that.password){
                    if($that.remember_pwd){
                      localStorage['userinfo_userpwd'] = $that.password;
                    }else{
                      localStorage.removeItem('userinfo_userpwd');
                    }
                  }
                  //成功跳转主页组件
                  $that.toTransfer(res.data.userType);
                }
                return;
              }else{
                $that.$toast('验证码错误');
              }
            });
          },
          sendCode:function () {
              var $that = this;
              let isSend = this.isSend;
              if(!this.username){
                $that.$toast('请输入手机号');
              }else if(this.username.length < 11){
                $that.$toast('请输入正确手机号');
              }else if(isSend){
                this.isSend = false;
                this.tips = '重新发送60s';
                var second = 60;
                var timer = setInterval(function () {
                  second--;
                  $that.tips = '重新发送'+second+'s';
                  if(second==0){
                    clearInterval(timer);
                    $that.tips = '发送验证码';
                    $that.isSend = true;
                  }
                },1000);
                //ajax
                this.$ajax.get(this.$$api.mobile.sendCode,{
                  'phone':this.username,
                });
              }
          },
          //展示隐藏密码
          eyeClick(e){
            var el = e.currentTarget;
            if(el.className == 'eye van-icon van-icon-closed-eye'){
              el.className = 'eye van-icon van-icon-eye-o'; //展示
              el.previousElementSibling.attributes.type.value = 'text';
            }else{
              el.className = 'eye van-icon van-icon-closed-eye'; //隐藏
              el.previousElementSibling.attributes.type.value = 'password';
            }
          },
          //忘记密码点击
          forgetClick(){
            var $that = this;
            var reg = /^[1][0-9]{10}$/;
            if(!reg.test($that.username)){
              this.$toast('请输入正确手机号');
              return
            }
            if($that.username){
              if($that.remember){
                localStorage['userinfo_username'] = $that.username;
              }else{
                localStorage.removeItem('userinfo_username');
              }
            }
            localStorage['reset_phone'] = this.username;
            this.$router.push({path:'/password-sms'});
            return;
          },
          loginTypeChange(){
            if(this.login_type == 'password'){
              this.login_type = 'sms'
            }else{
              this.login_type = 'password'
            }
          },
        chooseRole(item){
            this.id = item.id;
            this.roleParam.visible = false;
            this.login(item.id);
        },
        toTransfer(usertype){
            if(this.transfer.url){
            // if(this.transfer.url && usertype=='customer'){
              let obj = this.transfer.urlObj||{};
              let str = this.$comm.urlFormat(obj);
              this.$router.push('/'+this.transfer.url+'?'+str);
            }else{
              this.$router.push({path:'/main'});
            }
        },
        getUrlParams: function(name) {
          var url = window.location.href;
          var search_temp = '?' + url.split('?')[1];
          var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
          var r = search_temp.substr(1).match(reg);
          if (r != null)
            return r[2];
          return null;
        },
      }
    }
</script>

<style scoped>
  .container{
    background: #fff;
    width: 100vw;
    height: 100vh;
    overflow: scroll;
    margin-top:-9vh !important;
  }
  input{
    /*font-size: .5rem;*/
    font-size: 5vw;
  }
  .logo{
    width: 100vw;
    height: 40vw;
    text-align: center;
    /* margin-top: 13vh; */
    margin-top: 10vh;
    margin-bottom:2vh;
  }
  .logo img{
    max-width: 50%;
    max-height: 100%;
  }
  .group{
    width: 90%;
    margin: auto;
    /*height: 1rem;*/
    height: 10vw;
    overflow: hidden;
    /* margin-bottom: 8vw; */
    margin-bottom: 6vw;
    padding-bottom:.5vh;
  }
  .group:first-child{
    border-bottom: .7px solid #ccc;
  }
  .img{
    width: 15vw;
  }
  .img i{
    /*font-size: .8rem;*/
    font-size: 8vw;
  }
  .content input{
    width: 100%;
    height: 100%;
    outline: 0;
    border: 0;
    padding: 0;
  }
  .time{
    min-width: 26vw;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 3vw;
    text-align: center;
    margin-left: 3vw;
    border-radius: 5px;
    color: #fff;
    /*height: 1rem;*/
    height: 10vw;
    font-size: 3.65vw;
  }
  .border{
    border-bottom: .7px solid #ccc;
    width: 100%;
    overflow: hidden;
    padding-bottom:1vh;
  }
  .group:last-child{
    overflow: initial;
  }
  .opera{
    width: 100%;
    color:#fff;
    text-align: center;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    height: 13vw;
    line-height: 13vw;
    font-size: 5vw;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 6vh;
  }
  .fieldname{
    font-size: 18px;
    width:15vw;
  }
  .eye{
    line-height: 10vw;
    padding:0 5px;
    text-align: center;
    color: rgb(3,162,228);
    font-size: 18px;
  }
  .help{
    width:90%;
    margin:auto;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color:#8c8c8c;
  }
  .login_type{ /*登录方式切换*/
    width:100vw;
    /* height: 40vw; */
    /* line-height: 60vw; */
    line-height: 20vw;
    /* font-size:14px; */
    font-size:4vw;
    /* color:#8c8c8c; */
    color:rgb(3,162,228);
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue